import { buildApiUrl, ADMIN_ENDPOINTS } from '@/project/configs/api.js'

export default {
  url(payload) {
    return buildApiUrl(ADMIN_ENDPOINTS.REWARD_MILESTONES)
  },

  parse(raw = {}, payload = {}) {
    if (raw?.statusCode !== 200 && raw?.statusCode !== 201) {
      return {
        statusCode: raw?.statusCode || 500,
        message: raw?.message || 'Failed to contact server',
        data: null,
      }
    }

    // API returns { data: { data: [...], total, limit, offset } }
    const milestonesData = raw?.data?.data || []

    let data = milestonesData
    // === Recherche textuelle locale ===
    const searchTerm = (payload?.search || '').toString().trim().toLowerCase()
    if (searchTerm) {
      data = data.filter(el => {
        return Object.values(el).some(val => 
          val && typeof val !== 'object' && String(val).toLowerCase().includes(searchTerm)
        )
      })
    }

    // === Tri dynamique selon payload.sortKey et sortOrder ===
    const { sortKey, sortOrder } = payload || {}
    if (sortKey) {
      const order = sortOrder === 'desc' ? -1 : 1
      data = [...data].sort((a, b) => {
        const valA = a?.[sortKey]
        const valB = b?.[sortKey]
        if (typeof valA === 'string' && typeof valB === 'string') return valA.localeCompare(valB) * order
        if (typeof valA === 'number' && typeof valB === 'number') return (valA - valB) * order
        return 0
      })
    }

    const { page = 0, limit = 10000 } = payload || {}
    const paginated = data.slice(page * limit, (page + 1) * limit)

    return {
      statusCode: 200,
      message: 'Ok',
      data: {
        total: raw?.data?.total || milestonesData.length,
        result: paginated,
      },
    }
  },
}
